import moment from 'moment'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Link, useParams } from 'react-router-dom'

import { selectCurrentBalance, selectLoggedinUserName } from '../../../../accessors/index'
import CreditCard from '../../../../components/ReusableComponents/CreditCard/index'
import CreditCardForm from '../../../../components/ReusableComponents/MakePaymentDialog/CreditCardForm/index'
import useForm from '../../../../hooks/useForm'
import { getUSDstring } from '../../../../utils/helpers'
import { urlTypes } from '../paymentHelpers'
import styles from './MakeCreditCardPayment.module.scss'

const MakeCreditCardPayment = ({
  handleSubmit,
  savedPaymentMethods,
  selectedSavedPaymentMethodId,
  goBackPath,
  isAmountLocked,
  isAutoPay
}) => {
  const { type: paymentType } = useParams()

  const amount = Math.max(useSelector(selectCurrentBalance), 0)
  const currentUserName = useSelector(selectLoggedinUserName)

  // eslint-disable-next-line no-unused-vars
  const [values, handleChange, setValues] = useForm({
    PaymentClearedOn: moment().format('YYYY-MM-DD'),
    amount,
    uiAmount: getUSDstring(amount),
    chargeAmount: amount,
    uiChargeAmount: getUSDstring(amount),
    holder: currentUserName,
    pan: '',
    uiPan: '',
    expirationMonth: '',
    expirationYear: '',
    network: '',
    error: null,
    isOneTimeCard: false
  })

  const [usedSavedCC, setUsedSavedCC] = useState(null)

  const [isValid, setIsValid] = useState()

  useEffect(() => {
    const { amount, holder, error, chargeAmount } = values

    if (usedSavedCC && amount > 0) {
      setIsValid(true)
      return
    }

    if (parseFloat(chargeAmount) < parseFloat(amount)) {
      setIsValid(false)
      return
    }

    if (holder.length > 50) {
      setIsValid(false)
      return
    }

    if (
      (paymentType === urlTypes.payment ? amount > 0 : true) &&
      holder.match(/(\w.+\s).+/i) &&
      !error
    ) {
      setIsValid(true)
    } else {
      setIsValid(false)
    }
  }, [paymentType, usedSavedCC, values])

  useEffect(() => {
    if (selectedSavedPaymentMethodId) {
      const selectedMethod = savedPaymentMethods.find(
        method => method.paymentAccountId === selectedSavedPaymentMethodId
      )

      if (selectedMethod?.method === 'CreditCard') {
        setUsedSavedCC(selectedMethod)
      }
    }
  }, [savedPaymentMethods, selectedSavedPaymentMethodId])

  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        <div className={styles.cardHolder}>
          {usedSavedCC ? (
            <CreditCard
              holder={usedSavedCC.accountHolderName}
              last4={usedSavedCC.last4}
              expDate={convertDateFormat(usedSavedCC.expirationDate)}
            />
          ) : (
            <CreditCard {...values} />
          )}
        </div>
        <div className={styles.formContent}>
          <div className={styles.creditCardForm}>
            <CreditCardForm
              defaultValues={values}
              handleChange={setValues}
              isActivation={paymentType !== urlTypes.payment}
              usedSavedCC={usedSavedCC}
              isAmountLocked={isAmountLocked}
              isAutoPay={isAutoPay}
            />
            {}
          </div>
        </div>
      </div>
      <div className={styles.legalText}>
        By supplying this information and completing the transaction, I hereby authorize
        Directful Inc. to initiate a debit against the above credit card, and to charge
        the same to such credit card. I acknowledge that my Account must comply with the
        provisions of U.S. law.
      </div>
      <div className={styles.controls}>
        <Link to={goBackPath}>
          <button className={styles.secondaryButton}>Cancel</button>
        </Link>
        <button
          disabled={!isValid}
          className={styles.primaryButton}
          onClick={() => {
            handleSubmit({
              PaymentMethod: 'CreditCard',
              SubsidiaryBillingSavedPaymentAccountId:
                selectedSavedPaymentMethodId || null,

              CreditCard: selectedSavedPaymentMethodId
                ? null
                : {
                    Pan: +values.pan,
                    Cvv: +values.cvv,
                    Holder: values.holder,
                    ExpirationYear: +values.expirationYear,
                    ExpirationMonth: +values.expirationMonth,
                    Network: values.network
                  },
              PaymentAmount: parseFloat(values.amount),
              ChargeAmount: parseFloat(values.chargeAmount),
              SaveAccount: values.isOneTimeCard ? false : true
            })
          }}
        >
          {paymentType === urlTypes.payment
            ? 'Save & confirm payment'
            : 'Confirm details'}
        </button>
      </div>
    </div>
  )
}

export default MakeCreditCardPayment

function convertDateFormat(dateStr) {
  // Split the date string into month and year
  const [month, year] = dateStr.split('/')

  // Pad the month with a leading zero if necessary
  const paddedMonth = month.padStart(2, '0')

  // Take the last two digits of the year
  const shortYear = year.slice(-2)

  // Return the reformatted date string
  return `${paddedMonth}/${shortYear}`
}
